import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './native_css_badge.css';
export const NativeCssBadge = ({ label = 'Native CSS (global)' })=>/*#__PURE__*/ _jsxs("div", {
        className: "native-css-badge",
        "data-kind": "native-css",
        children: [
            /*#__PURE__*/ _jsx("span", {
                className: "native-css-badge__tag",
                children: "native css"
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "native-css-badge__label",
                children: label
            })
        ]
    });


export const knightedCss = ".native-css-badge,.knighted-native-css-badge,.knighted-knighted-native-css-badge,.knighted-knighted-knighted-native-css-badge,.knighted-knighted-knighted-knighted-native-css-badge{color:#e0f2fe;background:#1e3a8a59;border:1px solid #38bdf859;border-radius:16px;flex-direction:column;gap:.35rem;padding:.9rem 1.1rem;display:flex;box-shadow:0 16px 32px #02061759}.native-css-badge__tag,.knighted-native-css-badge__tag,.knighted-knighted-native-css-badge__tag,.knighted-knighted-knighted-native-css-badge__tag,.knighted-knighted-knighted-knighted-native-css-badge__tag{color:#0f172a;text-transform:uppercase;letter-spacing:.08em;background:#38bdf899;border-radius:999px;align-self:flex-start;padding:.2rem .6rem;font-size:.75rem;font-weight:700}.native-css-badge__label,.knighted-native-css-badge__label,.knighted-knighted-native-css-badge__label,.knighted-knighted-knighted-native-css-badge__label,.knighted-knighted-knighted-knighted-native-css-badge__label{margin:0;font-size:1rem;font-weight:600}";
